export const DELAY_PERIOD = 100
export const MAX_DELAY_PERIOD = 5000
export const REQUESTS_LIMIT = 250
export const KEEP_IN_MEMORY = 5 * 60 * 1000 // 5 minutes
export const CHAR_LIMIT = 10000 // the limit is only for one log item.
export const KIBANA_CHAR_LIMIT = 10000
export const CLIENT_DEBOUNCE_PERIOD = 5000
